import React from "react";
import { Stack, Skeleton } from "@mui/material";
import { range } from "lodash";

interface DatePickerSkeletonProps {
  rows?: number;
  columns?: number;
}

const DatePickerSkeleton: React.FC<DatePickerSkeletonProps> = ({
  rows = 5,
  columns = 7
}) => {
  return (
    <Stack direction="column" sx={{ mr: 2, mb: 2 }} spacing={1.5}>
      <Stack direction="row" gap={2} justifyContent="space-between">
        <Stack direction="row" gap={2}>
          <Skeleton variant="text" width={60} height={"40px"} />
          <Skeleton variant="text" width={60} />
        </Stack>
        <Stack direction="row" gap={1}>
          <Skeleton variant="text" width={40} height={"40px"} />
          <Skeleton variant="text" width={40} />
        </Stack>
      </Stack>

      <Stack direction="column" gap={2}>
        {range(0, rows).map((i) => (
          <Stack key={i} direction={"row"} spacing={2} width="100%">
            {range(0, columns).map((i) => (
              <Skeleton
                key={i}
                variant="rounded"
                height={32}
                sx={{ flex: 1 }}
              />
            ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export default DatePickerSkeleton;
